import { render } from "./GuideDetailPage.vue?vue&type=template&id=49f17b5a&scoped=true"
import script from "./GuideDetailPage.vue?vue&type=script&lang=js"
export * from "./GuideDetailPage.vue?vue&type=script&lang=js"

import "./GuideDetailPage.vue?vue&type=style&index=0&id=49f17b5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f17b5a"]])

export default __exports__